"use client";

import { agentsFiltersAtom } from "@/app/(saas)/(app)/business-brokers/_components/filters/state";
import { Icon } from "@/components/ui/icon";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAtom } from "jotai";
import { useTranslations } from "next-intl";
import { useEffect, useState } from "react";
import { useDebouncedCallback } from "use-debounce";

export function AgentNameSearchBox() {
  const t = useTranslations();

  const [filters, setFilters] = useAtom(agentsFiltersAtom);
  const [searchValue, setSearchValue] = useState<string>(filters.name ?? "");

  const handleInputChange = useDebouncedCallback((value: string) => {
    if (value === "" && !filters.location) {
      // empty string will just return all agents, we probably don't want that
      return;
    }

    setFilters((prev) => ({
      ...prev,
      name: value,
    }));
  }, 1000);

  useEffect(() => {
    if (searchValue === "" && filters.name) {
      // If the search value is empty, we reset the filter, should only happen
      // when the component is mounted (hopefully).
      setSearchValue(filters.name);
    }
  }, [filters.name]);

  return (
    <div className="flex flex-col gap-2">
      <Label className="text-base">
        {t("saas.agentSearch.form.name.label")}
      </Label>

      <div className="relative">
        <Icon
          icon="MagnifyingGlass"
          className="absolute top-1/2 left-4 -translate-y-1/2 opacity-50"
        />

        <Input
          value={searchValue}
          className="text-sm h-auto p-2 md:p-4 pl-12 md:pl-12"
          placeholder={t("saas.agentSearch.form.name.placeholder")}
          onChange={(e) => {
            setSearchValue(e.target.value);
            handleInputChange(e.target.value);
          }}
        />
      </div>
    </div>
  );
}

AgentNameSearchBox.displayName = "AgentNameSearchBox";
